import React from 'react';
import { useState } from 'react';
import { rebrand } from '../../../../theme/color';
import { IconListItem } from '../../atoms/IconListItem';
import { Tooltip } from '../../atoms/Tooltip';
import { InfoFilled } from '../../atoms/icons/InfoFilled';
import { V2PlanFeature } from '../../utilities/types';
import { style } from 'typestyle';
import { CloseCross } from '../../atoms/icons/CloseCross';
import { tooltipStyles } from '../../../../styles/tooltipStyles';

// Colour used for iconlist icons
const ICON_COLOR = rebrand.secondary[60].toString();

const styles = {
  tooltipIcon: style({
    display: 'inline-block',
  }),
};

interface PlanFeatureProps {
  feature: V2PlanFeature;
}

export const PlanFeature: React.FC<PlanFeatureProps> = ({ feature }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  if (!feature) return null;

  const tooltipContent = feature.tooltip_text ? (
    <span className={tooltipStyles.tooltipInner}>
      <span>{feature.tooltip_text}</span>
      <button className={tooltipStyles.tooltipCloseBtn} onClick={() => setShowTooltip(false)}>
        <CloseCross color="inherit" size={16} />
      </button>
    </span>
  ) : null;

  return (
    <IconListItem iconColor={ICON_COLOR} icon={feature.type}>
      {feature.tooltip_text ? (
        <Tooltip
          className={tooltipStyles.tooltip}
          wrapperClassName={styles.tooltipIcon}
          positions={['top', 'bottom']}
          show={showTooltip}
          disableOnMobile={false}
          onClickOutside={() => setShowTooltip(false)}
          content={tooltipContent}
        >
          <button className={tooltipStyles.tooltipBtn} onClick={() => setShowTooltip((val) => !val)}>
            {feature.text} <InfoFilled size={14} color={rebrand.contrast[40].toString()} />
          </button>
        </Tooltip>
      ) : (
        feature.text
      )}
    </IconListItem>
  );
};
